// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card__body{padding-top:10px!important;padding-bottom:0!important}.selectCriteria .el-form-item{margin-bottom:12px!important}", ""]);
// Exports
module.exports = exports;
